/**
 * Local environment service
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { IEnvironmentModel } from '../../interfaces/environment/environment-interfaces';

@Injectable({
  providedIn: 'root',
})
export class WdLocalEnvironmentService {
  public isInitialized = new BehaviorSubject(false);

  // Environment Values
  public values: IEnvironmentModel;

  /**
   * Constructor
   */
  constructor(
    @Inject('wdEnvironmentService') private wdEnvironmentService: any,
    private translate: TranslateService,
  ) {}

  /**
   * Initialize resources that comes for wd-library-environment
   */
  async initialize(): Promise<IEnvironmentModel> {
    this.values = await this.wdEnvironmentService.initialize();
    this.values.user = this.values.user.getInformation();
    // Set translation language
    this.translate.use(this.values.constants.getLocaleLanguage());
    // Set Initialized Flag
    this.isInitialized.next(true);
    return this.values;
  }
}
